import { type DocumentNode, gql } from '@apollo/client';

const createFieldMapsConfigMutation: DocumentNode = gql`
  mutation create_field_maps_config($name: String!) {
    createFieldMapConfig(name: $name) {
      fieldMapConfig {
        id
        name
      }
    }
  }
`;

export default createFieldMapsConfigMutation;
